import React from 'react';
import './RouteFallback.css';

/**
 * Suspense fallback for lazily-loaded route modules.
 *
 * Deliberately fades in after a short delay (see RouteFallback.css) so that an
 * already-cached chunk resolves before anything is painted — the common case on
 * repeat navigation, where a spinner would read as a flicker rather than as
 * progress. Only a genuinely slow fetch gets a visible spinner.
 *
 * All class names are `rf-` prefixed and the keyframes are `rf-spin`, not the
 * bare `.loading-spinner` / `spin` used across the page stylesheets — those
 * names are declared globally in several places with conflicting values.
 */
export default function RouteFallback({ label = 'Loading…' }) {
  return (
    <div className="rf-route-fallback" role="status" aria-live="polite">
      <div className="rf-spinner" aria-hidden="true" />
      <span className="rf-label">{label}</span>
    </div>
  );
}
